module.exports = __webpack_public_path__ + "static/media/rainy-1.f134a51c.svg";